module.exports = __webpack_public_path__ + "img/btn_copy_address.77091dd9.png";